<div
    #chipsContainer
    [id]="id"
    class="agpr-chipContainer"
    *ngIf="!(noContainerWhenEmpty && chips.length === 0)"
>
    <span
        *ngIf="chips.length === 0 && emptyMessage"
        class="agpr-chipContainer-emptyMessage"
    >
        {{ emptyMessage | localize }}
    </span>
    <agpr-button
        [id]="id + '_popoverToggle'"
        *ngIf="areChipsOverflowing && chips.length > 0 && !plainMode"
        class="agpr-chipContainer-more"
        [initiallyFocusable]="!isInTable"
        (click)="showPanel($event, chipsContainer)"
        [style]="buttonTypes.link"
        ariaHasPopup="dialog"
        [ariaControls]="id + '_chipPopover'"
        [expanded]="chipPopover.overlayVisible"
    >
        {{ overflowMessage | localize:{count: chips.length} }}
    </agpr-button>
    <ul
        #chipList
        [id]="id + '_chipList'"
        *ngIf="chips.length > 0"
        agprElementOverflowParent
        [elements]="chips"
        (isOverflowChange)="areChipsOverflowingChange($event)"
        class="agpr-chipContainer-list--group"
        [ngClass]="{
            'agpr-chipContainer-list': !plainMode,
            'agpr-chipContainer-list--overflow': areChipsOverflowing
        }"
        agprListKeyboardNavigation
        [listKeyboardNavigationDirectiveEnabled]="!isInTable && !readonly"
        listOrientation="horizontal"
        [focusOnChild]="true"
        [list]="chips"
        [wrap]="wrapChips"
        [attr.aria-hidden]="areChipsOverflowing"
        [attr.aria-labelledby]="ariaLabelledBy"
    >
        @for (chip of chips; track chip; let i = $index) {
            @let firstInFilter = chip?.labelArgs?.['firstInFilter'];
            @let firstInGroup = chip?.labelArgs?.['firstInGroup'];

            @if (firstInGroup || firstInFilter) {
                <span class="agpr-chipContainer-operators">
                    {{ firstInFilter ? '(' : firstInGroup ? (('and' | localize) + ' (') : '' }}
                </span>
            }
            <li
                [id]="id + '.chip-' + i"
                class="agpr-chip"
                [ngClass]="{
                    'agpr-chipContainer-chipsToken--social' : style === agprComponentStyle.social,
                    'agpr-infoChip': readonly
                }"
                [attr.aria-label]="chip.label ? (chip.label | localize: chip.labelArgs) : (chip | localize)"
            >
                <span
                    *ngIf="chip.label && !noTooltips && !chip.suffix"
                    class="agpr-chip-label"
                    [pTooltip]="chip.tooltip ? (chip.tooltip | localize) : (chip.label | localize:chip.labelArgs)"
                    tooltipPosition="bottom"
                >
                    {{ (chip.label | localize:chip.labelArgs) }}
                </span>
                <span
                    *ngIf="chip.label && chip.suffix"
                    class="agpr-chip-label"
                >
                    <span>{{ chip.label | localize: chip.labelArgs }}</span>
                    <span class="agpr-chip-suffix">{{ chip.suffix | localize }}</span>
                </span>
                <span
                    *ngIf="chip.label && noTooltips && !chip.suffix"
                    class="agpr-chip-label"
                >
                    {{ (chip.label | localize:chip.labelArgs) }}
                </span>
                <!-- plain string chip -->
                <span
                    *ngIf="!!chip && !chip.label && !noTooltips"
                    class="agpr-chip-label"
                    [pTooltip]="(style === agprComponentStyle.social ? chip : chip.tooltip ) | localize"
                    tooltipPosition="bottom"
                >
                    {{ chip | localize }}
                </span>
                <span
                    *ngIf="!!chip && !chip.label && noTooltips"
                    class="agpr-chip-label"
                >
                    {{ chip | localize }}
                </span>
                <agpr-button
                    *ngIf="!readonly"
                    [id]="id + '.popover.chip-' + i + '.delete'"
                    class="agpr-chip-button"
                    [style]="buttonTypes.icon"
                    [icon]="deleteIcon"
                    tooltip="Common.forms.chips.delete"
                    tooltipPosition="top"
                    (click)="onRemoveGroupedChip(chip, i, $event.currentTarget.parentElement.parentElement)"
                    (keydown)="onPanelKeydown($event)"
                    [ariaLabel]="((chip.label ? chip.label : chip) | localize: chip.labelArgs) + '' + ('Common.forms.chips.delete' | localize)"
                ></agpr-button>
            </li>
            @if(chip?.labelArgs?.['lastInGroup']) {
                <span class="agpr-chipContainer-operators">{{') '}}</span>
                @if(chip?.labelArgs?.['lastInFilter']) {
                    <br>
                }
            }
        }
    </ul>
</div>
<p-popover
    #chipPopover
    [id]="id + '_chipPopover'"
    *ngIf="!plainMode"
    [appendTo]="'body'"
    [baseZIndex]="1000"
    styleClass="agpr-clickOutsideExcluded agpr-chipContainer-popover"
    (onHide)="onHide()"
>
    <div
        class="agpr-chipContainer-popover-content"
    >
        <agpr-scroll-panel>
            @for (group of popoverChipGroups; track group) {
                @if (group.chips.length > 0) {
                    <div class="agpr-chipContainer-popover-group">
                        @if (group.label) {
                            <div class="agpr-chipContainer-popover-group-label">
                                {{ group.label | localize }}
                            </div>
                        }

                        <ul
                            class="agpr-chipContainer-list agpr-chipContainer-list--popover"
                            agprListKeyboardNavigation
                            listOrientation="horizontal"
                            [focusOnChild]="true"
                            [list]="group.chips"
                            role="group"
                            [attr.aria-label]="group.label | localize"
                        >
                            @for (chip of group.chips; track chip; let i = $index) {
                                @let firstInFilter = chip?.labelArgs?.['firstInFilter'];
                                @let firstInGroup = chip?.labelArgs?.['firstInGroup'];

                                @if (firstInGroup || firstInFilter) {
                                    <span class="agpr-chipContainer-operators">
                                        {{ firstInFilter ? '(' : firstInGroup ? (('and' | localize) + ' (') : '' }}
                                    </span>
                                }

                                <li
                                    [id]="id + '.popover.chip-' + i"
                                    class="agpr-chip"
                                    [ngClass]="{
                                        'agpr-chipContainer-chipsToken--social' : style === agprComponentStyle.social,
                                        'agpr-infoChip': readonly
                                    }"
                                    [attr.aria-label]="chip.label ? (chip.label | localize: chip.labelArgs) : (chip | localize)"
                                    [tabindex]="readonly ? 0 : -1"
                                >
                                    <span
                                        *ngIf="chip.label && chip.includeExclude"
                                        class="agpr-chip-label"
                                    >
                                        {{ chip.label | localize: chip.labelArgs }} ({{ chip.includeExclude | localize }})
                                    </span>

                                    <span
                                        *ngIf="chip.label && !chip.includeExclude"
                                        class="agpr-chip-label"
                                        [pTooltip]="chip.tooltip"
                                        tooltipPosition="bottom"
                                    >
                                        {{ (chip.label | localize: chip.labelArgs) + (chip.suffix | localize) }}
                                    </span>

                                    <span
                                        *ngIf="!!chip && !chip.label"
                                        class="agpr-chip-label"
                                        [pTooltip]="chip.tooltip"
                                        tooltipPosition="bottom"
                                    >
                                        {{ chip | localize }}
                                    </span>

                                    <agpr-button
                                        *ngIf="!readonly"
                                        [id]="id + '.popover.chip-' + i + '.delete'"
                                        class="agpr-chip-button"
                                        [style]="buttonTypes.icon"
                                        [icon]="deleteIcon"
                                        tooltip="Common.forms.chips.delete"
                                        tooltipPosition="top"
                                        (click)="onRemoveGroupedChip(chip, i, $event.currentTarget.parentElement.parentElement)"
                                        (keydown)="onPanelKeydown($event)"
                                        [ariaLabel]="((chip.label ? chip.label : chip) | localize: chip.labelArgs) + '' + ('Common.forms.chips.delete' | localize)"
                                    ></agpr-button>
                                </li>

                                @if(chip?.labelArgs?.['lastInGroup']) {
                                    <span class="agpr-chipContainer-operators">{{') '}}</span>

                                    @if(chip?.labelArgs?.['lastInFilter']) {
                                        <br>
                                    }
                                }
                            }
                        </ul>
                    </div>
                }
            }
        </agpr-scroll-panel>
        <agpr-button
            class="agpr-chipContainer-close"
            icon="fa-regular fa-duotone fa-close"
            tooltip="close"
            tooltipPosition="top"
            [style]="buttonTypes.icon"
            (click)="chipPopover.hide(); onHide();"
            (keydown)="onPanelKeydown($event)"
        ></agpr-button>
    </div>
</p-popover>
